export const SET_NOTIFICATIONS_INITIALIZE_COMPLETE = 'SET_NOTIFICATIONS_INITIALIZE_COMPLETE';
export const STAGE_GET_NOTIFICATION_MESSAGES = 'STAGE_GET_NOTIFICATION_MESSAGES';
export const HANDLE_GET_NOTIFICATION_MESSAGES = 'HANDLE_GET_NOTIFICATION_MESSAGES';
export const STAGE_PROCESSED_NOTIFICATION_RESPONSE = 'STAGE_PROCESSED_NOTIFICATION_RESPONSE';
export const UPDATE_POLLING_STATUS = 'UPDATE_POLLING_STATUS';



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/alme-notificationsapi/src/actions/actionTypes.js